import { useEffect } from 'react';
import { Formik, Form, useFormikContext, FormikHelpers, ErrorMessage } from 'formik';
import { Column } from '../../../../../core/components/Column';
import { Container } from '../../../../../core/components/Container';
import { CustomButton } from '../../../../../core/components/CustomButton';
import { Row } from '../../../../../core/components/Row';
import { TextComponent } from '../../../../../core/components/TextComponent';
import {
  BIRTHDAY_ADULT_MESSAGE,
  BirthFormValues,
  birthValidationSchema,
  formatDateInputValue,
  latestAdultBirthday,
  normalizeBirthDateValue,
} from '../../interfaces/BirthInterface';
import { useNavigate } from 'react-router-dom';
import { setUserInfo } from "../../store/OnboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../core/store/store";
import { DateInput } from "../../components/DateInput";


const SyncDateWithInputs: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  useEffect(() => {
    if (values.day && values.month && values.year) {
      const formattedDate = `${values.year}-${values.month.padStart(2, '0')}-${values.day.padStart(2, '0')}`;
      setFieldValue('date', formattedDate, false);
    }
  }, [values.day, values.month, values.year, setFieldValue]);

  return null;
};

export const OnboardingBirth: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const date = normalizeBirthDateValue(
    useSelector((state: RootState) => state.onboarding.userInfo?.birth),
  );
  const parts = date.split("-");
  const [year, month, day] = parts;
  const latestAdultDate = formatDateInputValue(latestAdultBirthday());
  const initialValues: BirthFormValues = {
    day,
    month,
    year,
    date,
  };

  const handleSubmit = (values: BirthFormValues, { setSubmitting }: FormikHelpers<BirthFormValues>) => {
    dispatch(setUserInfo({ birth: values.date }));
    navigate('/selectdetails');
    setSubmitting(false)
  };

  return (
    <Column
      crossAxisAlignment="center"
      className=""
    >
      <Container className='md:bg-white px-10 pb-10 md:my-10 md:p-20 self-center text-center w-full md:w-[584px] lg:shadow-xl rounded-lg gap-10'>
        <Column className='flex items-start mb-12'>
          <TextComponent variant='h2' className='font-bold'>
            Add Birthday
          </TextComponent>
          <TextComponent variant='h6' className='text-[#6B6B6B]'>
            Please add below your birthday
          </TextComponent>
        </Column>
        <Formik
          initialValues={initialValues}
          validationSchema={birthValidationSchema}
          validateOnBlur
          validateOnChange={false}
          onSubmit={handleSubmit}
        >
          {({ handleBlur, values, setFieldValue }) => (
            <Form className=''>
              <SyncDateWithInputs />
              <Column>
                <Row mainAxisAlignment='center' className='mb-4 gap-4'>
                  <DateInput
                    name="day"
                    value={values.day}
                    setFieldValue={setFieldValue}
                    handleBlur={handleBlur}
                    placeholder="DD"
                  />
                  <DateInput
                    name="month"
                    value={values.month}
                    setFieldValue={setFieldValue}
                    handleBlur={handleBlur}
                    placeholder="MM"
                  />
                  <DateInput
                    name="year"
                    value={values.year}
                    setFieldValue={setFieldValue}
                    handleBlur={handleBlur}
                    placeholder="YYYY"
                  />
                </Row>

                <Row className='mb-16'>
                  <Column className='w-full'>
                    <TextComponent variant='h6' className='text-center mb-2 font-medium'>
                      Select Date
                    </TextComponent>
                    <Column className="gap-1">
                      <input
                        type='date'
                        name='date'
                        value={values.date}
                        max={latestAdultDate}
                        onChange={(e) => {
                          setFieldValue('date', e.target.value);
                          const [year, month, day] = e.target.value.split('-');
                          setFieldValue('day', day);
                          setFieldValue('month', month);
                          setFieldValue('year', year);
                        }}
                        onBlur={handleBlur}
                        className='w-full text-center p-2 border border-gray-300 rounded'
                      />
                      <TextComponent variant='h6' className='text-[#6B6B6B] text-center'>
                        {BIRTHDAY_ADULT_MESSAGE}
                      </TextComponent>
                      <ErrorMessage name="date" component="div" className="text-red-500 text-xs" />
                    </Column>
                  </Column>
                </Row>
              </Column>
              <CustomButton type='submit' children='Continue' />
            </Form>
          )}
        </Formik>
      </Container>
    </Column>
  );
};
